import { LazyModule, createLazyComponent } from 'owa-bundling';

const lazyModule = new LazyModule(() => import(/* webpackChunkName: "LeftRail" */ './lazyIndex'));

export { default as onAppDrawerAppClick } from './actions/onAppDrawerAppClick';
export const AppDrawer = createLazyComponent(lazyModule, m => m.AppDrawer);
export { default as getM365AppData } from './selectors/getM365AppData';
